import { useRef, useState, useEffect } from "react";
import { useFrame } from "@react-three/fiber";
import { useScroll } from "@react-three/drei";
import MemberCircle from "../member/MemberCircle";
import { load } from "js-yaml";
import { Vector3 } from "three";
import { nanoid } from "nanoid";

export default function MemberFloating(props) {
  const scroll = useScroll();
  const [members, setMembers] = useState([]);
  const ref = useRef();

  useFrame((state, delta) => {
    // [설정/플로팅] 스크롤 기준 시작점 설정
    const startOffset = 0;
    const t = scroll.offset;
    // 스크롤이 충분히 내려오지 않으면 안보이는 곳으로 치우기
    ref.current.position.y =
      -120 + (Math.max(t - startOffset, 0) / (1 - startOffset)) * 100;
  });

  useEffect(() => {
    fetch("members.yaml")
      .then((r) => r.text())
      .then((text) => {
        return load(text);
      })
      .then((data) => {
        for (let i = 0; i < data.length; i++) {
          // 멤버 서클의 위치를 지정한 범위 내에서 무작위로 결정
          const x = (Math.random() - 0.5) * 20;
          const y = (Math.random() - 0.5) * 80;
          const z = (Math.random() - 0.5) * 40;
          data[i].position = new Vector3(x, y, z);
          data[i].num = i;
        }
        setMembers(data);
      });
  }, []);

  // [설정/플로팅] 빈 서클의 갯수
  const emptyCircleNumber = 300;
  let emptyCirclePositions = [];
  for (let i = 0; i <= emptyCircleNumber; i++) {
    const x = (Math.random() - 0.5) * 40;
    const y = (Math.random() - 0.5) * 80;
    const z = (Math.random() - 0.8) * 40;
    emptyCirclePositions.push(new Vector3(x, y, z));
  }

  return (
    <group ref={ref} position={props.center}>
      {members.map((member) => (
        <MemberCircle
          key={nanoid()}
          name={member.name}
          img={member.img}
          position={member.position}
          num={member.num}
          isMember={true}
          center={props.center}
          isDirected={false}
          isFloating={true}
        />
      ))}
      {emptyCirclePositions.map((p) => (
        <MemberCircle
          key={nanoid()}
          isMember={false}
          position={p}
          isFloating={true}
        />
      ))}
    </group>
  );
}
